import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import helpers from 'utils/helpers';
import { campaignActiveRequest } from 'ducks/campaigns';
import {
  StyledButton,
  StyledCampaignDetails,
  StyledCampaignPopupContainer
} from 'components/Styled';
import PureModal from 'business/components/pureModal/index';

const CampaignPopup = props => {
  const { user, campaignData } = props;
  const [display, setDisplay] = useState(false);

  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  const query = new URLSearchParams(location.search);
  const campaign = query.get('campaign');

  useEffect(() => {
    document.body.style.overflow = display ? 'hidden' : 'auto';
  }, [display]);

  useEffect(() => {
    if (
      campaign?.indexOf('MoneyBackpoints') !== -1 &&
      helpers.getCurrentCountry(true) === 'HK'
    ) {
      props.campaignActiveRequest({ campaignSlug: campaign });
    }
  }, [campaign]);

  useEffect(() => {
    if (props.suppressPopup) return;
    if (props.campaignData) setDisplay(true);
  }, [props.campaignData]);

  const onRegister = () => {
    setDisplay(false);
    const url = helpers.getRouteUrl('register');
    return history.push(url);
  };

  const onClose = () => {
    setDisplay(false);
    if (props.action) props.action();
    const url = helpers.getRouteUrl('create-shipment/quotation');
    return url;
  };

  const renderBody = () => {
    if (!campaignData) return null;
    const { name, title, subtitle, iconUrl, bannerUrl } = campaignData;

    return (
      <StyledCampaignPopupContainer>
        <div>
          <StyledCampaignDetails>
            <div className="name">{name[t('key')]}</div>
            <div className="title">{title[t('key')]}</div>
            <div>{subtitle[t('key')]}</div>
            <div style={{ textAlign: 'center', paddingTop: '20px' }}>
              <img className="campaign-icon" src={iconUrl[t('key')]} alt="" />
            </div>
            <div
              style={{
                textAlign: 'center',
                padding: '20px 0 20px 10px'
              }}>
              <img className="campaign-img" src={bannerUrl[t('key')]} alt="" />
            </div>
          </StyledCampaignDetails>
          <div style={{ padding: '0 20px 40px' }}>
            {!user && (
              <StyledButton
                onClick={onRegister}
                type="primary"
                shadow="true"
                style={{ marginBottom: 15 }}>
                {t('quotation.campaign.register')}
              </StyledButton>
            )}
            <StyledButton onClick={onClose} ghost type="primary" shadow="true">
              {t('quotation.campaign.quote')}
            </StyledButton>
          </div>
        </div>
      </StyledCampaignPopupContainer>
    );
  };

  return (
    <>
      {props.children}
      {display && (
        <PureModal
          visible={true}
          closeable={false}
          maskClosable={false}
          bodyStyle={{ width: 400, height: 'auto' }}>
          {renderBody()}
        </PureModal>
      )}
    </>
  );
};

const mapStateToProps = state => {
  return {
    campaignData: state.campaigns.campaignData,
    suppressPopup: !!state.campaigns.suppressPopup,
    user: !!state.auth.user
  };
};

const mapDispatchToProps = {
  campaignActiveRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignPopup);
